import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FourOFour } from './';

import * as contentActions from '../content.actions';

class ContentProvider extends Component {
  static propTypes = {
    content: PropTypes.object,
    loading: PropTypes.bool,
    slug: PropTypes.string.isRequired,
    readContent: PropTypes.func.isRequired,
    render: PropTypes.func.isRequired,
  };

  componentDidMount = () => {
    const { content, slug, readContent } = this.props;
    if (!content) {
      readContent(slug);
    }
  };

  componentDidUpdate = prevProps => {
    const { slug, readContent } = this.props;
    if (slug !== prevProps.slug) {
      readContent(slug);
    }
  };

  render() {
    const { content, loading } = this.props;
    if (content) return this.props.render(content);
    if (loading)
      return (
        <div
          style={{
            width: '100%',
            height: '100vh',
            position: 'relative',
          }}
        />
      );
    return <FourOFour />;
  }
}

const mapStateToProps = (state, { slug }) => {
  const content = state.entities.content.byId[slug] || null;
  const { loading } = state.entities.content;
  return {
    content,
    loading,
  };
};

export default connect(mapStateToProps, Object.assign({}, contentActions))(
  ContentProvider
);



// WEBPACK FOOTER //
// ./src/modules/content/components/ContentProvider.js